<footer class="py-10">
    <div class="container-p text-center text-sm text-gray-500 dark:text-gray-400">
        © {{year}} Sanju — Built with love ❣️
    </div>
</footer>